import React, { createContext, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useUser } from './UserContext';
import { Pages } from '../../AppRouter';

const ChangelogContext = createContext();

export function ChangelogProvider({ children }) {
    const { user } = useUser();
    const history = useHistory();
    const [releases, setReleases] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        checkVersions();
    }, [user.data]);

    const checkVersions = async () => {
        if (!user.data || !user.data.id) return;

        // Don't redirect checking if we are already on the changelog page
        // But we might want to load data regardless? 
        // Actually, if we are on changelog page, we might be there because of redirect.
        // Let's just fetch data. logic for redirecting is below.

        try {
            setLoading(true);
            const res = await fetch('/changelogs/versions.json');
            const data = await res.json();
            const lastSeen = user.data.userInformation?.lastSeenVersion;

            let newReleases = [];

            if (!lastSeen) {
                // If no last seen version, show only the latest version
                // Sort versions descending just in case, then check the first one
                const sortedVersions = data.versions.sort((a, b) => compareVersions(b.version, a.version));
                if (sortedVersions.length > 0) {
                    newReleases = [sortedVersions[0]];
                }
            } else {
                newReleases = data.versions.filter(v => compareVersions(v.version, lastSeen) > 0);
            }

            setReleases(newReleases);

            if (newReleases.length > 0) {
                if (history && history.location.pathname !== Pages.Changelog.Wizard) {
                    history.push(Pages.Changelog.Wizard);
                }
            }
        } catch (error) {
            console.error('Failed to check changelogs', error);
        } finally {
            setLoading(false);
        }
    };

    const compareVersions = (v1, v2) => {
        if (!v1 || !v2) return 0;
        const p1 = v1.split('.').map(Number);
        const p2 = v2.split('.').map(Number);
        for (let i = 0; i < Math.max(p1.length, p2.length); i++) {
            const n1 = p1[i] || 0;
            const n2 = p2[i] || 0;
            if (n1 > n2) return 1;
            if (n1 < n2) return -1;
        }
        return 0;
    };

    return (
        <ChangelogContext.Provider value={{ releases, loading, checkVersions }}>
            {children}
        </ChangelogContext.Provider>
    );
}

export function useChangelog() {
    return useContext(ChangelogContext);
}
